<script>
import { mapActions, mapState } from 'vuex';
import columns from '@/pages/promotions/promoCategories/columns';
import CreateCategory from '@/pages/promotions/promoCategories/createCategory/Create-category.vue';
import { CheckOutlined, EditOutlined } from '@ant-design/icons-vue';

export default {
  components: {
    CreateCategory,
    CheckOutlined,
    EditOutlined,
  },
  data() {
    return {
      columns: columns(),
      showCreate: false,
      selectedId: null,
      current: 1,
      pageSize: 10,
      offset: 0,
      editableData: {},
      selectedField: '',
    };
  },
  props: {
    checkedCategory: {
      type: Number,
      required: true,
    },
  },
  methods: {
    ...mapActions({
      getCategoriesAction: 'promotions/getPromoCategories',
      editCategoriesAction: 'promotions/editCategory',
      deleteCategoriesAction: 'promotions/deleteCategory',
    }),
    openCreateWindow() {
      this.showCreate = true;
    },
    getCategories() {
      const payload = {
        limit: this.pageSize,
        offset: this.offset,
      };
      this.getCategoriesAction(payload);
    },
    edit(value, fieldType) {
      this.editableData = value;
      this.selectedField = fieldType;
    },
    save(value) {
      this.editCategoriesAction({
        id: value.id,
        value: { name: value.name },
        params: {
          limit: this.pageSize,
          offset: this.offset,
        },
      });
      this.editableData = {};
      this.selectedField = '';
    },
    deleteCategory(id) {
      this.deleteCategoriesAction({
        id,
        params: {
          limit: this.pageSize,
          offset: this.offset,
        },
      });
    },
    setPagination(count) {
      this.current = count;
    },
    searchPromoCodeForCategory(id) {
      this.$emit('update:checkedCategory', id);
    },
  },
  mounted() {
    this.getCategories();
  },
  computed: {
    ...mapState({
      categories: (state) => state.promotions.categories,
    }),
  },
  watch: {
    current(newValue) {
      this.offset = (newValue - 1) * this.pageSize;
      this.getCategories();
    },
  },
};
</script>

<template>
  <div class="create-button">
    <a-button
      type="primary"
      html-type="button"
      @click="openCreateWindow"
    >
      Create category
    </a-button>
  </div>
  <div v-if="showCreate">
    <create-category
      v-model:show="showCreate"
      :page-size="pageSize"
      :offset="offset"
    />
  </div>
  <div v-if="categories && categories.length">
    <a-table
      :columns="columns"
      :dataSource="categories"
      :pagination="false"
    >
      <template #bodyCell="{ column, text, record }">
        <template v-if="column.dataIndex === 'name'">
          <div >
            <div v-if="
              editableData.name
              && editableData.name === record.name
              && selectedField === 'name'
            ">
              <a-input
                v-model:value="editableData.name"
                @pressEnter="save(record)"
                style="width: 300px"
              />
              <check-outlined @click="save(record)" />
            </div>
            <div v-else >
              {{ text || ' ' }}
              <edit-outlined @click="edit(record, 'name')" />
            </div>
          </div>
        </template>
        <template v-if="column.dataIndex === 'actions'">
          <div class="action-buttons">
            <a-button
              type="primary"
              html-type="button"
              @click="searchPromoCodeForCategory(record.id)"
            >
              Search
            </a-button>
            <a-popconfirm title="Sure to delete?" @confirm="deleteCategory(record.id)">
              <a-button type="primary" html-type="button" danger>
                Delete
              </a-button>
            </a-popconfirm>
          </div>
        </template>
      </template>
    </a-table>
    <div v-if="categories.length > 10" class="pagination" >
      <a-pagination
        v-model:current="current"
        v-model:pageSize="pageSize"
        total=""
        show-less-items
        @change="setPagination"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.create-button, .pagination {
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px;
}

button:last-child {
  margin-left: 20px;
}
</style>
